// @flow

import React from 'react'
import Path from 'routes/path'
import OwnerEvaluate from 'components/organisms/OwnerEvaluate'

export type PropTypes = {
  data: {
    room: Object,
  },
  addedFavoriteListName?: ?string,
  availablePoint?: ?string,
  favoritesCount: number,
  favorited: boolean,
  showingShare: boolean,
  showingFavoriteListTooltip: boolean,
  onClickShare: Function,
  onClickFavorite: Function,
  searchSessionId: string,
}

export default (props: PropTypes) => {
  const room = props.data.room

  const ownerEvaluateProps = {
    confirmRateEvaluation: room.owner.confirmRateEvaluation || '',
    confirmRateText: room.owner.confirmRateText || '',
    replyRateEvaluation: room.owner.replyRateEvaluation || '',
    replyRateText: room.owner.replyRateText || '',
    replyTimeAvgEvaluation: room.owner.replyTimeAvgEvaluation || '',
    replyTimeAvgText: room.owner.replyTimeAvgText || '',
  }

  return (
    <div className="space-side">
      <div className="space-side__box clearfix">
        <ul className="space__reserveinfo space-side__reserveinfo">
          {room.hasDirectReservationPlans && (
            <li className="space__reserveinfo-item space__reserveinfo-now">
              <i className="fa fa-bolt fa-lg icon-direct mr5" />
              {i18n.t('page.room.directOK')}
              <span className="mod-evaluate__help">
                <i className="fa fa-question-circle mod-evaluate__question" />
                <span className="mod-tooltip mod-evaluate__help-tooltip">
                  <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                    <span className="baloon-inner">
                      {i18n.t('page.room.captionDirectReservation')}
                    </span>
                  </span>
                </span>
              </span>
            </li>
          )}
          {room.reservableStart === 0 && (
            <li className="space__reserveinfo-item space__reserveinfo-today">
              <i className="icon icon-spm-dash fa-lg icon-direct mr5" />
              {i18n.t('page.room.todayOK')}
            </li>
          )}
        </ul>
        <div className="space-side__money">
          {room.prices.map((price, i) => (
            <p key={`room_prices_${i}`}>
              <strong>{price.minText}</strong>
              {price.minUnitText && (
                <React.Fragment>{`/${price.minUnitText}`}</React.Fragment>
              )}
              {price.maxText && (
                <React.Fragment>
                  ～<strong>{price.maxText}</strong>
                </React.Fragment>
              )}
              {price.maxUnitText && (
                <React.Fragment>{`/${price.maxUnitText}`}</React.Fragment>
              )}
            </p>
          ))}
          {props.availablePoint && (
            <p className="space-side__point-available" data-reactid="479">
              <span className="space-side__point-value" data-reactid="480">
                {props.availablePoint}
                円分
              </span>
              のポイントが利用可能
            </p>
          )}
          <ul className="space-side__note">
            <li>
              <i className="mr5 icon icon-spm-point icon-direct" />
              {i18n.t('page.room.point', { point: 3 })}
            </li>
            {room.hasLastMinuteDiscountPlans && (
              <li>
                <i className="mr5 icon icon-spm-discount icon-discount" />
                {i18n.t('page.room.lastMinuteDiscount.label1')}
                <span className="mod-evaluate__help">
                  <i className="fa fa-question-circle mod-evaluate__question" />
                  <span className="mod-tooltip mod-evaluate__help-tooltip">
                    <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                      <span className="baloon-inner">
                        {i18n.t('page.room.captionOwnerEvaluation')}
                      </span>
                    </span>
                  </span>
                </span>
              </li>
            )}
          </ul>

          <dl className="space-headnote pc-hide__sm-show">
            <dt className="space-headnote__title">
              {i18n.t('page.room.areaTitle')}
            </dt>
            <dd className="space-headnote__item">{room.area}㎡</dd>
            <dt className="space-headnote__title">
              {i18n.t('page.room.capacityTitle')}
            </dt>
            <dd className="space-headnote__item">
              {i18n.t('page.room.capacity', { capacity: room.capacity })}
            </dd>
          </dl>

          <div className="space-side__request-area">
            <a
              href={Path.reservationRequest(
                room.space.username,
                room.uid,
                null,
                props.searchSessionId,
              )}
              className="btn__large btn__style bg_blue"
            >
              {i18n.t('page.room.requestReservation1')}
              <br />
              {i18n.t('page.room.requestReservation2')}
            </a>
          </div>
          <ul className="space-side__buttons clearfix sm-hide">
            <li
              className={props.favorited ? 'space-side__buttons-fav__on' : ''}
            >
              <div className="space-side__buttons-list">
                <a
                  href=""
                  className="space-side__buttons-favorite"
                  onClick={props.onClickFavorite}
                >
                  <i className="fa fa-heart" />
                  {i18n.t('page.room.favorite')}
                  <span className="space-side__buttons-fav__count">
                    ({props.favoritesCount}
                    {props.favoritesCount > 999 ? '+' : ''})
                  </span>
                </a>
                {props.showingFavoriteListTooltip && (
                  <div className="space-side__favorite">
                    <div className="space-side__favorite-baloon">
                      <p className="space-side__favorite-baloon-text">
                        {props.addedFavoriteListName}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </li>
            <li className="space-side__buttons-fav__select">
              <div className="space-side__buttons-list">
                <a
                  href="#"
                  className={`space-side__buttons-select ${
                    props.favorited ? 'space-side-fa_buttons-select-on' : ''
                  }`}
                  onClick={props.onClickFavorite}
                >
                  <i className="fa fa-caret-down" />
                </a>
              </div>
            </li>
            <li className="space-side__buttons-share">
              <div className="space-side__buttons-list">
                <a
                  href="#"
                  onClick={e => {
                    props.onClickShare(e)
                  }}
                  className="space-side__button-share"
                >
                  <i className="fa fa-share-alt" />
                  {i18n.t('page.room.share')}
                </a>
                <div className="space-side__share-tooltip">
                  {props.showingShare ? (
                    <div className="baloon baloon-top user-detail-baloon space-side__share-baloon">
                      <div className="baloon-inner">
                        <ul className="space-side__social link__subcolor">
                          <li>
                            <a
                              href={Path.shareRoomTwitterUrl(room)}
                              target="_blank"
                            >
                              <i className="fa fa-twitter" />
                              twitter
                            </a>
                          </li>
                          <li>
                            <a
                              href={Path.shareRoomFacebookUrl(room)}
                              target="_blank"
                            >
                              <i className="fa fa-facebook-square" />
                              facebook
                            </a>
                          </li>
                          <li>
                            <a
                              href={Path.shareRoomLineUrl(room)}
                              target="_blank"
                            >
                              <i className="icon-spm-line" />
                              LINE
                            </a>
                          </li>
                          <li>
                            <a
                              href={Path.shareRoomGooglePlusUrl(room)}
                              target="_blank"
                            >
                              <i className="fa fa-google-plus-square" />
                              google＋
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="clearfix">
          <div className="space-side__owner-area">
            <OwnerEvaluate
              confirmRateEvaluation={ownerEvaluateProps.confirmRateEvaluation}
              confirmRateText={ownerEvaluateProps.confirmRateText}
              replyRateEvaluation={ownerEvaluateProps.replyRateEvaluation}
              replyRateText={ownerEvaluateProps.replyRateText}
              replyTimeAvgEvaluation={ownerEvaluateProps.replyTimeAvgEvaluation}
              replyTimeAvgText={ownerEvaluateProps.replyTimeAvgText}
            />
          </div>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailSideBox/index.jsx